import { all, call, put, takeLatest } from 'redux-saga/effects'

import {
    companyPaymentWithNoCardData,
    companyPaymentWithOnlineBanking,
    feeCalculator,
    ledgerTopUpWithNoCardData,
    ledgerTopUpWithOnlineBanking,
    mergedFeeCalculator,
    orderNewLedger,
    parseBankAccountWithCurrency,
    parseBankInternalTransfer,
    sepaBankTranfer,
} from 'api/apiDataHelpers'
import { getRequest, getRequestV2, getRequestV3, getRequestV5, postRequest, postRequestV2, postRequestV3 } from 'api/apiUtils'
import * as allAssetsActions from 'redux/allAssets/allAssets-actions.js'
import * as dashboardActions from 'redux/dashboard/dashboard-actions.js'
import LedgerActionTypes from 'redux/ledger/ledger-types'
import UserActionTypes from 'redux/user/user-types'

import {
    failure3dSecureCard,
    failure3dSecureCompanyPaymentByCard,
    failure3dSecureCompanyPaymentByOnlineBanking,
    failure3dSecureOnlineBank,
    failureBankAccountOrder,
    failureBankAccountTopUpWithCurrency,
    failureBankAccountWithdrawWithCurrency,
    failureBankBic,
    failureBankInternalTransfer,
    failureCompanyPaymentByCard,
    failureCompanyPaymentByOnlineBanking,
    failureCountriesList,
    failureExchangeAllAssets,
    failureFeeCalculator,
    failureGetMaxAmount,
    failureLedgerTopUpWithNoCardData,
    failureLedgerTopUpWithOnlineBank,
    failureMergedFeeCalculator,
    failureOrderCurrency,
    failureOrderMultiCurrency,
    failurePayNow,
    failureTopUpWithBankTransfer,
    failureTransfer,
    failureTransferFromIbanToBank,
    failureTransferToBank,
    failureTransliterationTransferReference,
    startCountriesList,
    success3dSecureCard,
    success3dSecureCompanyPaymentByCard,
    success3dSecureCompanyPaymentByOnlineBanking,
    success3dSecureOnlineBank,
    successBankAccountOrder,
    successBankAccountTopUpWithCurrency,
    successBankAccountWithdrawWithCurrency,
    successBankBic,
    successBankInternalTransfer,
    successCompanyPaymentByCard,
    successCompanyPaymentByOnlineBanking,
    successCountriesList,
    successExchangeAllAssets,
    successFeeCalculator,
    successFetchLedgerCurrenciesId,
    successGetMaxAmount,
    successLedgerTopUpWithNoCardData,
    successLedgerTopUpWithOnlineBank,
    successMergedFeeCalculator,
    successOpenBankAccountsAvailable,
    successOrderCurrency,
    successOrderMultiCurrency,
    successPayNow,
    successTopUpWithBankTransfer,
    successTransfer,
    successTransferFromIbanToBank,
    successTransferToBank,
    successTransliterationTransferReference,
    successUserBankAccountsId,
} from './ledger-actions'

function* startFetchCurrenciesId({ payload: { id } }) {
    try {
        const { data } = yield getRequestV2(`/user/assets/currencies/${id}`)

        yield put(successFetchLedgerCurrenciesId(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log('err fetching currencies id', err?.response?.data)
        }
    }
}
export function* onFetchCurrenciesId() {
    yield takeLatest(LedgerActionTypes.START_FETCH_CURRENCIES_ID, startFetchCurrenciesId)
}

function* fetchBankAccountsId({ payload: { id } }) {
    try {
        const { data } = yield getRequestV5(`/user/assets/bankAccounts/${id}`)

        yield put(successUserBankAccountsId(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log('err fetching cards', err?.response?.data)
        }
    }
}

export function* onStartUserBankAccountsId() {
    yield takeLatest(LedgerActionTypes.START_USER_BANK_ACCOUNTS_ID, fetchBankAccountsId)
}

function* fetchAllCountries() {
    try {
        const { data } = yield getRequest('/countries')

        yield put(successCountriesList(data))
    } catch (err) {
        yield put(failureCountriesList({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureCountriesList', err?.response?.data)
        }
    }
}

export function* onStartCountriesList() {
    yield takeLatest(LedgerActionTypes.START_COUNTRIES_LIST, fetchAllCountries)
}

function* fetchData() {
    yield put(dashboardActions.startFetchDashboards())
    yield put(allAssetsActions.startFetchAllAssets())
    yield put(startCountriesList())
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, fetchData)
}

function* onRefresh() {
    yield put(dashboardActions.startFetchDashboards())
}

export function* onRefreshDashboards() {
    yield takeLatest(LedgerActionTypes.REFRESH_DATA, onRefresh)
}

function* startBankAccountOrder({ payload }) {
    try {
        const { data } = yield postRequestV3('/user/assets/bankAccounts', payload)

        yield put(successBankAccountOrder(data))
    } catch (err) {
        yield put(failureBankAccountOrder({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureBankAccountOrder', err)
        }
    }
}

export function* onOrderBankAccount() {
    yield takeLatest(LedgerActionTypes.START_BANK_ACCOUNT_ORDER, startBankAccountOrder)
}

function* startOpenBankAccountsAvailable() {
    try {
        const { data } = yield getRequestV3('/user/assets/bankAccounts/available')

        yield put(successOpenBankAccountsAvailable(data))
    } catch (err) {
        const error = 'ERROR fetchOpenBankAccounts'

        if (process.env.NODE_ENV !== 'production') {
            console.log(error)
        }
    }
}

export function* onStartOpenBankAccountsAvailable() {
    yield takeLatest(LedgerActionTypes.START_OPEN_BANK_ACCOUNTS_AVAILABLE, startOpenBankAccountsAvailable)
}

function* startLedgerTopUpWithBankTransfer({ payload: { type, fromAsset, amount } }) {
    try {
        const parsedData = yield sepaBankTranfer({ type, fromAsset, amount })
        const { data } = yield postRequest('/user/assets/currencies/deposits/bank', parsedData)
        const { data: transactionData } = yield getRequest(`/user/assets/transfers/${data.no}`)

        yield put(successTopUpWithBankTransfer({ successData: transactionData }))
    } catch (err) {
        yield put(failureTopUpWithBankTransfer({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureTopUpWithBankTransfer')
        }
    }
}

export function* onLedgerTopUpWithBankTransfer() {
    yield takeLatest(LedgerActionTypes.START_TOP_UP_WITH_BANK_TRANSFER, startLedgerTopUpWithBankTransfer)
}

function* startLedgerTopUpWithNoCardData({ payload: { amount, currencyCode, id } }) {
    try {
        const parsedValues = ledgerTopUpWithNoCardData({ amount, currencyCode })
        const { data } = yield postRequest(`/user/assets/${id}/card-charges`, parsedValues)

        yield put(successLedgerTopUpWithNoCardData(data))
    } catch (err) {
        yield put(
            failureLedgerTopUpWithNoCardData({ errorMessage: err?.response?.data?.errors || [{ message: 'Deposit by Card failed' }] })
        )
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureLedgerTopUpWithNoCardData')
        }
    }
}

export function* onLedgerTopUpWithBankNoCardData() {
    yield takeLatest(LedgerActionTypes.START_LEDGER_TOP_UP_WITH_NO_CARD_DATA, startLedgerTopUpWithNoCardData)
}

function* startLedgerTopUpWithOnlineBanking({ payload: { amount, currencyCode, id } }) {
    try {
        const parsedValues = ledgerTopUpWithOnlineBanking({ amount, currencyCode })
        const { data } = yield postRequest(`/user/assets/${id}/bank-charges`, parsedValues)

        yield put(successLedgerTopUpWithOnlineBank(data))
    } catch (err) {
        yield put(failureLedgerTopUpWithOnlineBank({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureLedgerTopUpWithOnlineBank')
        }
    }
}

export function* onLedgerTopUpWithOnlineBanking() {
    yield takeLatest(LedgerActionTypes.START_LEDGER_TOP_UP_WITH_ONLINE_BANK, startLedgerTopUpWithOnlineBanking)
}

function* start3dSecureCard({ payload: { id } }) {
    try {
        const { data } = yield getRequest(`/user/assets/card-charges/${id}`)

        yield put(success3dSecureCard({ status: data?.status, successData: data?.amount }))
    } catch (err) {
        yield put(failure3dSecureCard({ errorMessage: err?.response?.data?.errors || [{ message: '3D Secure failed' }] }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failure3dSecureCard', err?.response?.data?.errors)
        }
    }
}

export function* onStart3dSecureCard() {
    yield takeLatest(LedgerActionTypes.START_SECURE_3D_CARD, start3dSecureCard)
}

function* start3dSecureOnlineBank({ payload: { id } }) {
    try {
        const { data } = yield getRequest(`/user/assets/bank-charges/${id}`)

        yield put(success3dSecureOnlineBank({ status: data?.status, successData: data?.amount }))
    } catch (err) {
        yield put(failure3dSecureOnlineBank({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failure3dSecureOnlineBank', err?.response?.data?.errors)
        }
    }
}

export function* onStart3dSecureOnlineBank() {
    yield takeLatest(LedgerActionTypes.START_SECURE_3D_ONLINE_BANK, start3dSecureOnlineBank)
}

function* startBankInternalTransfer({ payload: { accountNumber, amount, currencyCode, paymentReference, verificationCode, identifier } }) {
    try {
        const responseData = yield parseBankInternalTransfer({ accountNumber, amount, currencyCode, paymentReference, verificationCode })
        const { data } = yield postRequest(`/user/assets/bank-accounts/${identifier}/internal-transfers`, responseData)
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(successBankInternalTransfer({ successData: transactionData }))
    } catch (err) {
        yield put(failureBankInternalTransfer({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureBankInternalTransfer', err)
        }
    }
}

export function* onStartBankInternalTransfer() {
    yield takeLatest(LedgerActionTypes.START_BANK_ACCOUNT_INTERNAL_TRANSFER, startBankInternalTransfer)
}

function* startBankAccountTopUpWithCurrency({ payload: { value, currencyCode, accountNumber } }) {
    try {
        const responseData = yield parseBankAccountWithCurrency({ value, currencyCode, accountNumber })
        const { data } = yield postRequest('/user/assets/bankAccounts/deposits/currency', responseData)
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(successBankAccountTopUpWithCurrency({ successData: transactionData }))
    } catch (err) {
        yield put(failureBankAccountTopUpWithCurrency({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureBankAccountTopUpWithCurrency', err)
        }
    }
}

export function* onStartBankAccountTopUpWithCurrency() {
    yield takeLatest(LedgerActionTypes.START_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY, startBankAccountTopUpWithCurrency)
}

function* startBankAccountWithdrawWithCurrency({ payload: { value, currencyCode, accountNumber } }) {
    try {
        const responseData = yield parseBankAccountWithCurrency({ value, currencyCode, accountNumber })
        const { data } = yield postRequest('/user/assets/bankAccounts/withdrawals/currency', responseData)
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(successBankAccountWithdrawWithCurrency({ successData: transactionData }))
    } catch (err) {
        yield put(failureBankAccountWithdrawWithCurrency({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureBankAccountWithdrawWithCurrency', err)
        }
    }
}

export function* onStartBankAccountWithdrawWithCurrency() {
    yield takeLatest(LedgerActionTypes.START_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY, startBankAccountWithdrawWithCurrency)
}

function* startFeeCalculator({ payload: { amount, fromAsset, toAsset, feeKey, service } }) {
    try {
        const responseData = yield feeCalculator({ amount, fromAsset, toAsset, service })
        const { data } = yield postRequestV2(`/user/fees/${feeKey}/amounts`, responseData)

        yield put(successFeeCalculator(data))
    } catch (err) {
        yield put(failureFeeCalculator({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureFeeCalculator', err)
        }
    }
}

export function* onStartFeeCalculator() {
    yield takeLatest(LedgerActionTypes.START_FEE_CALCULATOR, startFeeCalculator)
}

function* startMergedFeeCalculator({ payload: { sourceAccountId, targetAccountId, transferIntent, currencyCode, amount } }) {
    try {
        const responseData = yield mergedFeeCalculator({ sourceAccountId, targetAccountId, transferIntent, currencyCode, amount })
        const { data } = yield postRequest('/user/merged-fees', responseData)

        yield put(successMergedFeeCalculator(data))
    } catch (err) {
        yield put(failureMergedFeeCalculator({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureMergedFeeCalculator', err)
        }
    }
}

export function* onStartMergedFeeCalculator() {
    yield takeLatest(LedgerActionTypes.START_MERGED_FEE_CALCULATOR, startMergedFeeCalculator)
}

function* startExchangeAllAssets({ payload: { amount, accountId, targetId } }) {
    try {
        const { data } = yield postRequestV2('/user/assets/currencies/exchanges', {
            amount,
            sourceAccountId: accountId,
            targetAccountId: targetId,
        })
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(successExchangeAllAssets(transactionData))
    } catch (err) {
        yield put(failureExchangeAllAssets({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureExchangeAllAssets')
        }
    }
}

export function* onStartExchangeAllAssets() {
    yield takeLatest(LedgerActionTypes.START_EXCHANGE_All_ASSETS, startExchangeAllAssets)
}

function* startTransferFromLedgerToLedger({ payload: { formData } }) {
    try {
        const { data } = yield postRequestV2('/user/assets/currencies/transfers', formData)
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(successTransfer(transactionData))
    } catch (err) {
        yield put(failureTransfer({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureTransfer')
        }
    }
}
export function* onStartTransferFromLedgerToLedger() {
    yield takeLatest(LedgerActionTypes.START_TRANSFER, startTransferFromLedgerToLedger)
}

function* startGetMaxAmount({ payload: { exchangeCurrencyCode, key, service, accountId } }) {
    try {
        const { data: feeData } = yield postRequestV2(`/user/fees/max/${key}`, { accountId, service, exchangeCurrencyCode })

        yield put(successGetMaxAmount({ successData: feeData }))
    } catch (err) {
        yield put(failureGetMaxAmount({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureGetMaxAmount', err)
        }
    }
}

export function* onStartGetMaxAmount() {
    yield takeLatest(LedgerActionTypes.START_GET_MAX_AMOUNT, startGetMaxAmount)
}

function* startTransferFromLedgerToBank({ payload: { formData } }) {
    try {
        const { data } = yield postRequestV3('/user/assets/currencies/withdrawals/bank', formData)
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(successTransferToBank(transactionData))
    } catch (err) {
        yield put(failureTransferToBank({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureTransferToBank', err)
        }
    }
}
export function* onStartTransferFromLedgerToBank() {
    yield takeLatest(LedgerActionTypes.START_TRANSFER_TO_BANK, startTransferFromLedgerToBank)
}

function* startTransferFromIbanToBank({ payload: { formData } }) {
    try {
        const { data } = yield postRequestV3('/user/assets/bankAccounts/withdrawals/bank', formData)
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(successTransferFromIbanToBank({ successData: transactionData }))
    } catch (err) {
        yield put(failureTransferFromIbanToBank({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureTransferFromIbanToBank', err)
        }
    }
}

export function* onStartTransferFromIbanToBank() {
    yield takeLatest(LedgerActionTypes.START_TRANSFER_FROM_IBAN_TO_BANK, startTransferFromIbanToBank)
}

function* startOrderMultiCurrency({ payload: { fiat, crypto, tokens } }) {
    try {
        if (fiat?.some(Boolean)) {
            yield postRequest('/user/assets/currencies/multiple', { currencyCodes: fiat })
        }
        if (crypto?.some(Boolean)) {
            yield postRequestV2('/user/digitalAssets/wallets/multiple', { currencyCodes: crypto })
        }
        if (tokens?.some(Boolean)) {
            yield postRequest('/user/tokens/multiple', { currencyCodes: tokens })
        }
        yield put(successOrderMultiCurrency())
    } catch (err) {
        yield put(failureOrderMultiCurrency({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureOrderMultiCurrency')
        }
    }
}
export function* onStartOrderMultiCurrency() {
    yield takeLatest(LedgerActionTypes.START_ORDER_MULTI_CURRENCY, startOrderMultiCurrency)
}

function* startOrderCurrency({ payload: { currencyCode } }) {
    try {
        const responseData = yield orderNewLedger({ currencyCode })

        yield postRequest('/user/assets/currencies', responseData)
        yield put(successOrderCurrency())
    } catch (err) {
        yield put(failureOrderCurrency({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureOrderCurrency')
        }
    }
}
export function* onStartOrderCurrency() {
    yield takeLatest(LedgerActionTypes.START_ORDER_CURRENCY, startOrderCurrency)
}

function* startPayNow({ payload: { no, verificationCode } }) {
    try {
        yield postRequestV2(`/payments/${no}/pay`, { verificationCode })
        yield put(successPayNow())
    } catch (err) {
        yield put(failurePayNow({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failurePayNow')
        }
    }
}
export function* onStartPayNow() {
    yield takeLatest(LedgerActionTypes.START_PAY_NOW, startPayNow)
}

function* startBankBic({ payload: { account } }) {
    try {
        const { data } = yield getRequest(`/banks/ibans/${account}/bic`)

        yield put(successBankBic({ ...data, noValidateIban: !data, account }))
    } catch (err) {
        if (err?.response?.status === 404) {
            yield put(successBankBic({ noValidateIban: false, account }))
        } else {
            yield put(failureBankBic({ errorMessage: err?.response?.data?.errors }))
            if (process.env.NODE_ENV !== 'production') {
                console.log('failureBankBic')
            }
        }
    }
}
export function* onStartBankBic() {
    yield takeLatest(LedgerActionTypes.START_BANK_BIC, startBankBic)
}

function* startCompanyPaymentCard({ payload: { amount, currencyCode } }) {
    try {
        const parsedValues = companyPaymentWithNoCardData({ amount, currencyCode })
        const { data } = yield postRequest('/user/company-payments/card-charges', parsedValues)

        yield put(successCompanyPaymentByCard(data))
    } catch (err) {
        yield put(failureCompanyPaymentByCard({ errorMessage: err?.response?.data?.errors || [{ message: 'Deposit by Card failed' }] }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureCompanyPaymentByCard')
        }
    }
}
export function* onStartCompanyPaymentCard() {
    yield takeLatest(LedgerActionTypes.START_COMPANY_PAYMENT_CARD, startCompanyPaymentCard)
}

function* start3dSecureCompanyCardPayment({ payload: { id } }) {
    try {
        const { data } = yield getRequest(`/user/company-payments/card-charges/${id}`)

        yield put(success3dSecureCompanyPaymentByCard({ status: data?.status, successData: data?.amount }))
    } catch (err) {
        yield put(failure3dSecureCompanyPaymentByCard({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failure3dSecureCompanyPaymentByCard', err?.response?.data?.errors)
        }
    }
}

export function* onStart3dSecureCompanyCardPayment() {
    yield takeLatest(LedgerActionTypes.START_SECURE_3D_COMPANY_CARD_PAYMENT, start3dSecureCompanyCardPayment)
}

function* startCompanyPaymentOnlineBanking({ payload: { amount, currencyCode } }) {
    try {
        const parsedValues = companyPaymentWithOnlineBanking({ amount, currencyCode })
        const { data } = yield postRequest('/user/company-payments/bank-charges', parsedValues)

        yield put(successCompanyPaymentByOnlineBanking(data))
    } catch (err) {
        yield put(
            failureCompanyPaymentByOnlineBanking({
                errorMessage: err?.response?.data?.errors || [{ message: 'Deposit by Online Banking failed' }],
            })
        )
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureCompanyPaymentByOnlineBanking')
        }
    }
}
export function* onStartCompanyPaymentOnlineBanking() {
    yield takeLatest(LedgerActionTypes.START_COMPANY_PAYMENT_ONLINE_BANKING, startCompanyPaymentOnlineBanking)
}

function* start3dSecureCompanyOnlineBankingPayment({ payload: { id } }) {
    try {
        const { data } = yield getRequest(`/user/company-payments/bank-charges/${id}`)

        yield put(success3dSecureCompanyPaymentByOnlineBanking({ status: data?.status, successData: data?.amount }))
    } catch (err) {
        yield put(failure3dSecureCompanyPaymentByOnlineBanking({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failure3dSecureCompanyPaymentByOnlineBanking', err?.response?.data?.errors)
        }
    }
}

export function* onStart3dSecureCompanyOnlineBankingPayment() {
    yield takeLatest(LedgerActionTypes.START_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT, start3dSecureCompanyOnlineBankingPayment)
}

function* startTransliterationTransferReference({ payload: { iban, text } }) {
    try {
        const {
            data: { transliteratedText },
        } = yield postRequest('/transliterator', { iban: iban.replace(/ /g, ''), text })

        yield put(successTransliterationTransferReference(transliteratedText))
    } catch (err) {
        yield put(failureTransliterationTransferReference({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('failureTransliterationTransferReference', err?.response?.data?.errors)
        }
    }
}

export function* onStartTransliterationTransferReference() {
    yield takeLatest(LedgerActionTypes.START_TRANSLITERATION_TRANSFER_REFERENCE, startTransliterationTransferReference)
}

export function* ledgerSagas() {
    yield all([
        call(onFetchCurrenciesId),
        call(onSignSuccess),
        call(onOrderBankAccount),
        call(onLedgerTopUpWithBankTransfer),
        call(onStartBankAccountTopUpWithCurrency),
        call(onStartBankAccountWithdrawWithCurrency),
        call(onStartFeeCalculator),
        call(onStartExchangeAllAssets),
        call(onRefreshDashboards),
        call(onStartTransferFromLedgerToLedger),
        call(onStartGetMaxAmount),
        call(onStartTransferFromLedgerToBank),
        call(onStartTransferFromIbanToBank),
        call(onStartOrderCurrency),
        call(onStartPayNow),
        call(onStart3dSecureCard),
        call(onStartOpenBankAccountsAvailable),
        call(onStartUserBankAccountsId),
        call(onStartCountriesList),
        call(onStartOrderMultiCurrency),
        call(onStartBankInternalTransfer),
        call(onLedgerTopUpWithBankNoCardData),
        call(onStartBankBic),
        call(onStart3dSecureOnlineBank),
        call(onLedgerTopUpWithOnlineBanking),
        call(onStartMergedFeeCalculator),
        call(onStartCompanyPaymentCard),
        call(onStart3dSecureCompanyCardPayment),
        call(onStartCompanyPaymentOnlineBanking),
        call(onStart3dSecureCompanyOnlineBankingPayment),
        call(onStartTransliterationTransferReference),
    ])
}
